/**
 * Retries a dynamically-imported webpack chunk once after a short delay if the
 * first attempt fails (e.g. a transient network blip or CDN hiccup timing out
 * the chunk request) instead of leaving fireReadyToRender()'s catch to show a
 * fatal error on the very first hiccup — see NTH-INVESTOR-PORTAL-EM, GH #5994.
 *
 * Extracted into its own module (rather than living inline in index.js) so it
 * can be unit tested without needing to load the whole app bundle.
 *
 * @param {() => Promise<any>} importFn - a thunk wrapping a dynamic import(), e.g. `() => import('./foo.js')`
 * @param {number} retriesLeft - how many more attempts remain after this one
 * @param {number} delayMs - delay before retrying, in milliseconds
 * @returns {Promise<any>} resolves with the import's module, or rejects with the last error once retries are exhausted
 */
export function retryDynamicImport(importFn, retriesLeft = 1, delayMs = 1500) {
	return importFn().catch((err) => {
		if (retriesLeft <= 0) throw err;
		console.warn('Dynamic import failed, retrying in ' + delayMs + 'ms:', err);
		return new Promise((resolve) => setTimeout(resolve, delayMs)).then(() => retryDynamicImport(importFn, retriesLeft - 1, delayMs));
	});
}
